import { render } from "./pzDevice.vue?vue&type=template&id=13b35b67"
import script from "./pzDevice.vue?vue&type=script&lang=js"
export * from "./pzDevice.vue?vue&type=script&lang=js"

import "./pzDevice.vue?vue&type=style&index=0&id=13b35b67&lang=css"

import exportComponent from "/root/qzf/src/invoice-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__